/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskUpdateCallOutcome = typeof TaskUpdateCallOutcome[keyof typeof TaskUpdateCallOutcome] | null;


export const TaskUpdateCallOutcome = {
  connected: 'connected',
  voicemail: 'voicemail',
  no_answer: 'no_answer',
  wrong_number: 'wrong_number',
  disconnected: 'disconnected',
  other: 'other',
} as const;
